/**
 * Created by Hardy on 2018/1/23.
 */
//全局使用的MUTATIONS

import * as types from './types'

export default {
  //存储我的预约所有订单
  [types.MYORDER_ALL](state,payload){
    state.is_update_contacts = payload;
  },
  [types.IS_UPDATE_CONTACTS](state,payload){
    state.myorder = payload;
  },
  // loading
  [types.UPDATE_LOADING] (state,payload){
    state.isLoading = payload;
  },
  // 医生详细信息
  [types.UPDATE_DOCSELFINFO] (state,payload){
    state.docInfo = payload;
  //  复制一份医生信息
    state.docInfoCopy = Object.assign({},payload);
  },
  //待办事项  咨询条数更新
  [types.UPDATE_UNREPLAY](state,payload){
    state.unReplay.status = payload;
  },
  // 会员信息
  [types.UPDATE_PATSELFINFO](state,payload){
    state.patInfo = payload;
  },
  //医生信息状态是否更新
  [types.IS_UPDATE_DOCINFO](state,payload){
    state.is_update_doc = payload;
  },
  //用户信息状态是否更新
  [types.IS_UPDATE_PATINFO](state,payload){
    state.is_update_doc = payload;
  },
  [types.UPDATE_CHAT_SET](state,payload){
    state.docInfo.chat_switch = payload;
  },
  [types.UPDATE_REVIEW_SET](state,payload){
    state.docInfo.review_switch = payload;
  },
  //用户查看图片预览
  [types.SET_IMG_ARR](state,payload){
    switch (payload.way){
      case 'push':
        if(payload.msg.data){
          state.img.push(payload.msg.data.text.src);
        }else{
          state.img.push(payload.msg);
        }
        break;
      case 'unshift':
        if(payload.msg.data){
          state.img.unshift(payload.msg.data.text.src);
        }else{
          state.img.unshift(payload.msg);
        }
        break;
      case 'clear':
        state.img = [];
        break;
      case 'concat':
        state.img = (state.img).concat(payload.msg);
        break;
    }
  },
  // 储蓄医生的研究编号
  [types.MY_RESEARCH_NUMBER] (state, payload) {
    window.sessionStorage.setItem('researchNumber', payload)
    state.researchNumber = payload
  },
  // 是否展示返回键
  [types.RESEARCH_BACK] (state, payload) {
    state.research_back = payload
  },
  // 存储当前的 research_answer_id
  [types.RESEARCH_ANSWER_ID] (state, payload) {
    window.localStorage.setItem('RESEARCH_ANSWER_ID', payload)
    state.research_answer_id = payload
  },






}



// WEBPACK FOOTER //
// ./src/vuex/rootMutations.js